import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeMode = 'light' | 'dark' | 'system'

interface ThemeState {
  theme: ThemeMode
  setTheme: (theme: ThemeMode) => void
}

/** Kullanıcı tercihi; sunucu durumu değildir, bu yüzden `localStorage`'da kalması sorun değil. */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme })
      },
    }),
    { name: 'betontasdash.ui' },
  ),
)

function systemPrefersDark(): boolean {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function resolveIsDark(theme: ThemeMode): boolean {
  return theme === 'dark' || (theme === 'system' && systemPrefersDark())
}

/** `document.documentElement`'e `.dark` sınıfını uygular. Sağlayıcı bunu izler. */
export function applyThemeClass(theme: ThemeMode): void {
  document.documentElement.classList.toggle('dark', resolveIsDark(theme))
}
